(() => {
  'use strict';
  if (window.ddUvLightBound) return;
  window.ddUvLightBound = true;
  let saving = false;
  const isCheckout = element => element instanceof Element && element.closest('[name="checkout"],[id="CartDrawer-Checkout"],a[href*="/checkout"]');
  document.addEventListener('click', event => { if (saving && isCheckout(event.target)) event.preventDefault(); }, true);
  document.addEventListener('submit', event => { if (saving && event.submitter && isCheckout(event.submitter)) event.preventDefault(); }, true);
  document.addEventListener('change', async event => {
    const input = event.target;
    if (!(input instanceof HTMLInputElement) || !input.matches('[data-dd-uv-cart-key]')) return;
    const wanted = input.checked, root = input.closest('[data-dd-uv-option]'), status = root.querySelector('[data-dd-uv-status]');
    const ar = document.documentElement.lang.startsWith('ar');
    if (saving) { input.checked = !wanted; return; }
    saving = true;
    const controls = [...document.querySelectorAll('cart-drawer input, cart-drawer button, cart-items input, cart-items button, [name="checkout"]')].filter(control => !control.disabled);
    controls.forEach(control => { control.disabled = true; });
    input.disabled = true;
    status.textContent = ar ? 'جارٍ حفظ اختياركم…' : 'Saving your choice…';
    try {
      const base = window.Shopify.routes.root;
      const cartResponse = await fetch(base + 'cart.js', {headers:{Accept:'application/json'},cache:'no-store'});
      if (!cartResponse.ok) throw new Error('cart');
      const cart = await cartResponse.json();
      const line = cart.items.find(item => item.key === input.dataset.ddUvCartKey);
      if (!line) throw new Error('line');
      const properties = {...line.properties, 'Free UV light': wanted ? input.value : 'Not requested'};
      const response = await fetch(base + 'cart/change.js', {method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({id:line.key,quantity:line.quantity,properties})});
      if (!response.ok) throw new Error('save');
      window.location.assign(base + 'cart');
    } catch (error) {
      input.checked = !wanted;
      status.textContent = ar ? 'تعذّر حفظ الاختيار. يرجى المحاولة مجدداً قبل إتمام الطلب.' : 'Your choice could not be saved. Please try again before checkout.';
      controls.forEach(control => { if(control.isConnected) control.disabled = false; });
      input.disabled = false;
      saving = false;
    }
  });
})();
